import logo from "../../assets/logoLight.svg";
import modeIcon from "../../assets/modeIconLight.svg";
import heartLike from "../../assets/heartLikeLight.svg";

// eslint-disable-next-line
export default {
  title: "light",

  colors: {
    background: "#F4F4F4",
    card: "#ffffff",
    separetor: "#71E025",
    detail: "#71E025",
    title: "#000000",
    text: "#5E5E5E",
    buttonText: "#2C2C2C",
    date: "#70E864",
  },
  logo: logo,
  mode: {
    icon: modeIcon,
    text: "Dark Mode",
  },
  heartLike: heartLike,
};
